<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div class="title">
  <h4>Entre em contato</h4>
  <p>Não encontrou o que procurava nas Dúvidas Frequentes? Envie sua dúvida e responderemos por e-mail.</p>
</div>

<form [formGroup]="contatoForm" class="contato-form">
  <mat-form-field appearance="outline" class="form-field">
    <textarea matInput placeholder="Escreva sua mensagem*" formControlName="mensagem" rows="6" maxlength="1000"
      class="textarea-message" required></textarea>
  </mat-form-field>
  <p>Máximo de 1.000 caracteres</p>

  <div class="button">
    <button matButton="filled"  type="button" (click)="sendContact()" [disabled]="contatoForm.invalid || isLoading">
      Enviar
    </button>
  </div>
</form>